import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../../environments/environment';


export class UserLocalStorageObject {
  username: string;
  sessionToken: string;
  constructor(
    username: string, sessionToken: string) {
    this.username = username;
    this.sessionToken = sessionToken;
  }
}


@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  public userLocalStorageInserted = new BehaviorSubject(this.getUserLocalStorageObject());


  constructor() { }

  private _getLocalStorage(uniqueId: string) {
    return localStorage.getItem(uniqueId);
  }

  private _setLocalStorage(key: string, value: string) {
    localStorage.setItem(key, value);
  }

  /**
   * USER LOCAL STORAGE
   */
  public userLocalStorageExist(): boolean {
    return !!this._getLocalStorage(environment.userSessionUniqueId);
  }

  public getUserLocalStorageObject(): UserLocalStorageObject {
    const currentLocalStorage = this._getLocalStorage(environment.userSessionUniqueId);
    return currentLocalStorage !== null ? JSON.parse(currentLocalStorage) : new UserLocalStorageObject('', '');
  }

  public setUserLocalStorage(key: keyof UserLocalStorageObject, value: string) {
    const localStorage = this._getLocalStorage(environment.userSessionUniqueId);
    const localStorageObject: UserLocalStorageObject = localStorage !== null ? JSON.parse(localStorage) : new UserLocalStorageObject('', '');
    localStorageObject[key] = value;
    this._setLocalStorage(environment.userSessionUniqueId, JSON.stringify(localStorageObject));
    this.userLocalStorageInserted.next(localStorageObject);
  }

}
